export const QA_BANNER_HEIGHT_PX = 40;

export function getAppEnvironment(value: string | undefined = process.env.REACT_APP_ENV): string {
  const normalized = value?.trim().toLowerCase();
  return normalized || "local";
}

export function isQaBannerEnabled(env: string = getAppEnvironment()): boolean {
  return env === "qa";
}

export function getQaBannerOffsetPx(env: string = getAppEnvironment()): number {
  return isQaBannerEnabled(env) ? QA_BANNER_HEIGHT_PX : 0;
}
